<template>
  <div v-if="mobile">
    <v-btn-toggle
      v-model="period"
      class="w-full"
      variant="flat"
      width="100%"
      rounded="lg"
      border
      divided
    >
      <v-btn
        v-for="(period, i) in periods"
        :key="`p-${i}`"
        :value="period.value"
        class="flex-grow"
        rounded="0"
      >
        {{ period.title }}
      </v-btn>
    </v-btn-toggle>
  </div>
  <v-card v-else class="px-4 flex-center!" variant="flat" rounded="lg" link>
    <span class="flex-align gap-1 min-w-80px justify-center">
      <Icon class="mt-0.5" name="heroicons:calendar-days-16-solid" />
      <span>{{ activePeriodTitle }}</span>
    </span>
    <v-menu
      activator="parent"
      location="bottom"
      transition="slide-y-transition"
      offset="15"
    >
      <v-card class="py-2">
        <v-item-group v-model="period">
          <div v-for="item in periods" :key="item.value">
            <v-item v-slot="{ isSelected, toggle }" :value="item.value">
              <v-list-item
                @click="toggle"
                :title="item.title"
                :subtitle="item.description"
              >
                <template #prepend>
                  <span class="mr-2 flex-align">
                    <v-icon size="20">
                      {{
                        isSelected
                          ? "radio_button_checked"
                          : "radio_button_unchecked"
                      }}
                    </v-icon>
                  </span>
                </template>
              </v-list-item>
            </v-item>
          </div>
        </v-item-group>
      </v-card>
    </v-menu>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useDisplay } from "vuetify";
import { useVModel } from "@vueuse/core";

export default defineComponent({
  name: "MetricsPeriodSelect",
  props: {
    modelValue: { type: String, default: "today" },
    metricsKey: { type: String, default: "default" },
  },
  setup(props) {
    const { mobile } = useDisplay();
    const period = useVModel(props, "modelValue");

    const periods = [
      {
        title: "Today",
        value: "today",
        description: "From start of day to current hour",
      },
      {
        title: "7 days",
        value: "days:7",
        description: "From previous 7 days to current hour",
      },
      ...(mobile.value
        ? []
        : [
            {
              title: "30 days",
              value: "days:30",
              description: "From previous 30 days to current hour",
            },
            {
              title: "Last 12 months",
              value: "months:12",
              description: "From previous 12 months to current hour",
            },
            {
              title: "This year",
              value: "year",
              description: `From year to date (${now()
                .startOf("year")
                .format("MMM")}—Today)`,
            },
            {
              title: "Last year",
              value: "years:1",
              description: "From last year (Jan—Dec)",
            },
          ]),
      {
        title: "All time",
        value: "all",
        description: "From start of time to current hour",
      },
    ];

    return {
      mobile,
      period,
      periods,
    };
  },
  computed: {
    activePeriodTitle() {
      const active = findWhere(this.periods, {
        value: this.period,
      });
      return active?.title;
    },
  },
});
</script>
